import type { Role } from '@/entities/auth';

const ROLE_PERMISSIONS_STORAGE_KEY = 'role_permissions_override';

export type RolePermissionsMap = Record<string, string[]>;

export const saveRolePermissions = (rolePermissions: RolePermissionsMap): void => {
  localStorage.setItem(ROLE_PERMISSIONS_STORAGE_KEY, JSON.stringify(rolePermissions));
};

export const getRolePermissions = (): RolePermissionsMap | null => {
  const stored = localStorage.getItem(ROLE_PERMISSIONS_STORAGE_KEY);
  if (!stored) return null;

  try {
    return JSON.parse(stored) as RolePermissionsMap;
  } catch {
    return null;
  }
};

export const clearRolePermissions = (): void => {
  localStorage.removeItem(ROLE_PERMISSIONS_STORAGE_KEY);
};

export const checkRoutePermission = (userRoles: Role[], pathname: string): boolean => {
  const customPermissions = getRolePermissions();

  if (customPermissions) {
    return userRoles.some((role) => {
      const allowedRoutes = customPermissions[role] || [];
      return allowedRoutes.some((route) => pathname.startsWith(route));
    });
  }

  return true;
};
